/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const digipass_private_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={24}
    fill="none"
    viewBox="0 0 26 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M6.75 6.803C3.163 7.84.75 9.779.75 12c0 2.22 2.413 4.16 6 5.197m0-10.394c1.765-.51 3.814-.803 6-.803 6.627 0 12 2.686 12 6s-5.373 6-12 6c-2.186 0-4.235-.292-6-.803m0-10.394c.75 1.697 1.8 6.152 0 10.394M12 12h6.75"
    />
  </svg>
)
export default digipass_private_medium
